<!--
iconClass  对应svg文件的文件名称，传入后自动组装成iconName
customColor 自定义图标颜色
customWidth 自定义宽度
customHeight 自定义高度
verticalAlign 纵向偏移
-->
<template>
  <div>
    <!-- v-on="$listeners" 允许父组件的事件直接作用到<svg>标签上 -->
    <svg class="svg-icon" :style="customStyle" aria-hidden="true" v-on="$listeners">
      <use :xlink:href="iconName" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'TSvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    customColor: {
      type: String,
      default: ''
    },
    customWidth: {
      type: String,
      default: ''
    },
    customHeight: {
      type: String,
      default: ''
    },
    verticalAlign: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    customStyle() {
      let resultStyle = ''
      if (this.customColor !== '') {
        resultStyle += `fill: ${this.customColor}; stroke:${this.customColor};`
      }
      if (this.customWidth !== '') {
        resultStyle += `width: ${this.customWidth};`
      }
      if (this.customHeight !== '') {
        resultStyle += `height: ${this.customHeight};`
      }
      if (this.verticalAlign !== '') {
        resultStyle += `vertical-align: ${this.verticalAlign};`
      }
      return resultStyle
    }
  }
}
</script>

<style scoped>
/*如需修改width,height,fill,stroke等样式，请在外部使用 /deep/ .svg-icon的方式修改样式*/
.svg-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  overflow: hidden;
}
</style>
